import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Resource, ResourceStatusConfigMap, ResourceStatus } from "../../../../../store/ResourcesListStore";

export default class Status extends React.Component<IListViewFieldColumn<Resource>> {
    public render() {
        return <StatusView status={this.props.entity.attributes.Status} />;
    }
}

export class StatusView extends React.Component<{ status?: ResourceStatus }> {
    render() {
        const config = this.props.status !== undefined ? ResourceStatusConfigMap[this.props.status] : undefined;
        return (
            <div className="resource-status">
                <div className={`align-center status ${config ? config.cssClassName : ''}`}>
                    {config ? config.title : this.props.status}
                </div>
            </div>
        );
    }
}